module.exports = __webpack_public_path__ + "img/cash.2c8ad253.svg";